import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import uuid from 'uuid-random';
import SectionLayout from '../SectionLayout';
import { ReputationSelectors } from '../../ducks/reputation';
import { dataRatingsAdapter } from '../dataRatingsAdapter';
import EmptyStateScore from '../EmptyStateScore';
import Comment from '../Comment';
import {
  Container,
  MainArea,
  LeftSide,
  BottomSheetContainer,
  BottomSheetTitle,
  CommentsContainer,
  MobileBajadaContainer,
  Disclamer,
  SpanText
} from './styles';
import './buttonSheetStyles.css';

const DisclaimerSection = ({ device, reloadDispatch, error = false }) => {
  const { t } = useTranslation();
  const isMobile = device === 'mobile';
  const [ratingsData, setRatingsData] = useState({});
  const [, setProgressBarData] = useState([]);
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const { ratings, customersComments } = useSelector(ReputationSelectors.getReputationState);

  const { responseTime, postingContent, attention, recommendYou, notRespondedCount } = ratingsData;

  useEffect(() => {
    if (ratings) setRatingsData(dataRatingsAdapter(ratings));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratings]);

  useEffect(() => {
    setProgressBarData([
      { value: postingContent },
      { value: responseTime },
      { value: attention },
      { value: recommendYou }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratingsData]);

  const handleClick = () => {
    window.open(t('panel.reputacion.disclamer.link.T&C'));
  };

  const getTopEmptyState = () => {
    if (device === 'mobile') return '20px';
    if (device === 'desktop') return '0px';
    return '30px';
  };

  return (
    <SectionLayout
      data-panel='panel-estadisticas-ratings'
      marginTop='0px'
      paddingTop={10}
      padding={8}
      paddingBottom={notRespondedCount ? '24' : null}
      border='none'
    >
      {device === 'desktop' && (
        <Container>
          {!error ? (
            <MainArea device={device} notRespondedCount={notRespondedCount}>
              <LeftSide device={device} data-panel='ratings-container-leftSide'>
                <div
                  style={{
                    fontFamily: 'Hind',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '22.41px'
                  }}
                >
                  <Disclamer>
                    {t('panel.reputacion.disclaimer')}
                    <SpanText onClick={handleClick}>{t('panel.reputacion.disclamer.link')}</SpanText>
                  </Disclamer>
                </div>
              </LeftSide>

              {isMobile && (
                <BottomSheet
                  open={openBottomSheet}
                  onDismiss={() => setOpenBottomSheet(false)}
                  snapPoints={({ maxHeight }) => [maxHeight / 1.12]}
                  header={React.createElement(
                    'div',
                    {},
                    <BottomSheetTitle data-panel='ratings-bottomSheet-title'>
                      {t('panel.estadisticas.ratings.moreComments.title')}
                    </BottomSheetTitle>
                  )}
                >
                  <BottomSheetContainer>
                    <CommentsContainer height='429px' data-panel='ratings-bottomSheet-container'>
                      {customersComments &&
                        customersComments.map(customerComment => (
                          <Comment key={uuid()} customerComment={customerComment} keyId={uuid()} />
                        ))}
                    </CommentsContainer>
                  </BottomSheetContainer>
                </BottomSheet>
              )}
            </MainArea>
          ) : (
            <EmptyStateScore
              withSpacing={device === 'desktop'}
              height={isMobile ? '160px' : '115px'}
              top={getTopEmptyState()}
              callback={reloadDispatch}
              text={t('panel.reputacion.permanence.title')}
            />
          )}
        </Container>
      )}

      {!error && device !== 'desktop' && (
        <Container>
          <MobileBajadaContainer>
            <Disclamer>
              {t('panel.reputacion.disclaimer')}
              <SpanText onClick={handleClick}>{t('panel.reputacion.disclamer.link')}</SpanText>
            </Disclamer>
          </MobileBajadaContainer>
        </Container>
      )}

      {error && device !== 'desktop' && (
        <EmptyStateScore
          withSpacing={device === 'desktop'}
          height={isMobile ? '160px' : '115px'}
          callback={reloadDispatch}
          text={t('panel.reputacion.permanence.title')}
        />
      )}
    </SectionLayout>
  );
};

export default DisclaimerSection;
